import { PackageNativeExchangeUnitMap } from '@mntn-dev/commerce-config'
import type {
  ExchangeUnit,
  PackageDomainQueryModel,
} from '@mntn-dev/domain-types'

import { convertExchangeUnits } from './convert-exchange-units.ts'

type FilterPackagesByCreditBalanceInput<T extends PackageDomainQueryModel> = {
  creditBalances: Record<string, number | undefined>
  packages: Array<T>
  packagesExchangeUnit?: ExchangeUnit
}
export const filterPackagesByCreditBalance = <
  T extends PackageDomainQueryModel,
>({
  creditBalances,
  packages,
  packagesExchangeUnit = 'USD',
}: FilterPackagesByCreditBalanceInput<T>) => {
  // Return packages that don't have a PackageSource in creditBalances
  // and packages where the cost is less than or equal to the credit balance of the matching ExchangeUnit
  return packages.filter((pkg) => {
    const creditExchangeUnit = PackageNativeExchangeUnitMap.get(
      pkg.packageSource
    )
    const balance = creditBalances[creditExchangeUnit]
    if (balance === undefined) {
      return true
    }
    const creditBalance = convertExchangeUnits(
      balance,
      creditExchangeUnit,
      packagesExchangeUnit
    )
    return pkg.costPlusMargin <= creditBalance
  })
}
